import { useMemo } from 'react'

import { useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'
import handleCallbackAction from '@functions/handleCallbackAction'

import ManageSubscribersModal from '@modals/ManageSubscribersModal'

import type { SubscriberModel } from '@models/types'

import PageContent from './components/PageContent'

export type PageContextPayload = {
  callbacks: {
    showManageSubscribersModal: () => void,
  },
}

const defaultState = {
  showManageSubscribersModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    ManageSubscribersModal: {
      closeModal: () => setState({ showManageSubscribersModal: false }),
      createSubscriber: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      deleteSubscriber: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const ConversationList = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showManageSubscribersModal,
  } = state

  const modalContext = useModals({ setState })
  const { callbacks: { setModalData } } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      showManageSubscribersModal: (payload: { subscriber: SubscriberModel }) => {
        setModalData('ManageSubscribersModal', payload)
        setState({ showManageSubscribersModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent />

        <ManageSubscribersModal
          callbacks={callbacks('ManageSubscribersModal', setState)}
          showModal={showManageSubscribersModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default ConversationList
